import { BackendCaller } from '@/common/secondary/BackendCaller';
import { ClubSlug } from '@/fairplayer/domain/club/ClubSlug';
import { Auction } from '@/fairplayer/domain/exclusive/Auction';
import { AuctionRepository } from '@/fairplayer/domain/exclusive/AuctionRepository';
import { BackendAuction, toAuction } from '@/fairplayer/secondary/exclusive/BackendAuction';

export class BackendAuctionRepository implements AuctionRepository {
  constructor(private backendCaller: BackendCaller) {}

  listByClub(clubSlug: ClubSlug): Promise<Auction[]> {
    return this.backendCaller
      .get<BackendAuction[]>(`api/clubs/${clubSlug}/auctions`)
      .then(auctions => auctions.data.filter(auction => auction.visible).map(toAuction));
  }
}
